/*
 * Bildspalte der Produktseite läuft beim Scrollen mit, bis die Buybox endet.
 *
 * Das eigentliche Kleben macht CSS (position: sticky auf .product__media-wrapper).
 * Nur der top-Wert kommt von hier: ist die Galerie höher als das Fenster, muss er
 * negativ sein, sonst pinnt sticky sofort die Oberkante und die unteren Bilder
 * bekäme man beim Scrollen nie zu sehen. Der Überhang hängt von Bildanzahl und
 * Seitenverhältnis ab, ist also nicht in CSS ausdrückbar.
 */
(() => {
  const OFFSET = 30; // 3rem, gleicher Abstand wie bei Dawns sticky-Infospalte

  const update = (wrapper) => {
    const top = Math.min(OFFSET, window.innerHeight - wrapper.offsetHeight - OFFSET);
    wrapper.style.setProperty('--gallery-sticky-top', `${Math.round(top)}px`);
  };

  const wrappers = document.querySelectorAll('.product--stacked .product__media-wrapper');
  if (!wrappers.length) return;

  wrappers.forEach((wrapper) => {
    update(wrapper);

    // Bilder werden lazy nachgeladen, die Höhe steht also nicht sofort fest.
    if ('ResizeObserver' in window) {
      new ResizeObserver(() => update(wrapper)).observe(wrapper);
    }
  });

  window.addEventListener('resize', () => wrappers.forEach(update));
})();
